import requestFunctions from "../../functions/requestFunctions";


export const state = {
  BOTS_ITEM: {},
  BOTS_LIST: [],
  BOTS_TABLE_DATA: [],
  BOTS_LIST_DATA: [],
  BOTS_TOTAL_ROWS: 0
}

export const getters = {
  GET_BOTS_ITEM: (state) => {
    return state.BOTS_ITEM;
  },
  GET_BOTS_LIST: (state) => {
    return state.BOTS_LIST;
  },
  GET_BOTS_TABLE_DATA: (state) => {
    return state.BOTS_TABLE_DATA;
  },
  GET_BOTS_LIST_DATA: (state) => {
    return state.BOTS_LIST_DATA;
  },
  GET_BOTS_TOTAL_ROWS: (state) => {
    return state.BOTS_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_BOTS_ITEM(state, item) {
    state.BOTS_ITEM = item;
  },

  UPDATE_BOTS_LIST(state, list) {
    
    state.BOTS_LIST = list.data;

    state.BOTS_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.BOTS_TABLE_DATA = [];
    state.BOTS_LIST_DATA = [];    

    list.forEach(el => {

      let user_data = '';
    
      if(el.profile_fullname !== null){
        user_data = el.profile_fullname;
      }
      
      if(el.user_phone !== null ){
        if(user_data !== ''){
          user_data = user_data + ', ';
        }
        user_data = user_data + el.user_phone;
      }
  
      // if(el.account_number !== null ){
      //   if(user_data !== ''){
      //     user_data = user_data + ', ';
      //   }
      //   user_data = user_data + el.account_number;
      // }
  
      let dev_data = '';

      if(el.dev_profile_fullname !== null){
        dev_data = el.dev_profile_fullname;
      }
      
      if(el.dev_phone !== null ){
        if(dev_data !== ''){
          dev_data = dev_data + ', ';
        }
        dev_data = dev_data + el.dev_phone;
      }
  
      // if(el.dev_account_number !== null ){
      //   if(dev_data !== ''){
      //     dev_data = dev_data + ', ';
      //   }
      //   dev_data = dev_data + el.dev_account_number;
      // }

      state.BOTS_TABLE_DATA.push({
        'name' : el.name,
        'id' : el.id,
        'description' : el.description,
        'user_data' : user_data,
        'dev_data' : dev_data,
        'trunk_name' : el.trunk_name,
        'trunk_phone_number' : el.trunk_phone_number,
        'updated_at' : el.updated_at,
        'created_at' : el.created_at,
        'version' : el.version,
        'uuid' : el.uuid,
        'fl_enabled' : el.fl_enabled !== false
      });

      state.BOTS_LIST_DATA.push({
        id: el.id,
        uuid: el.uuid,
        name: el.name,
      });
    });
  },
}

export const actions = {

  async FETCH_BOTS_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/bots/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_BOTS_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_BOTS_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.client.za-bota.com/v1/bots';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_BOTS_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_BOTS_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/bots';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_BOTS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/bots/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_BOTS_SET_ENABLED({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/bots/'+payload.uuid+'/enabled';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_BOTS_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/bots/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}